//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'TIMI_STEMI',
  data() {
    return {
      form: {
        age: '0',
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '0',

      },
      ageList: [
        { value: '3', name: '年龄≥75岁' },
        { value: '2', name: '年龄65~74岁' }
      ],
      hasScore: false,
      disabled: false,
      descTxt: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (form.item2 == 1) {
        form.item2 = 3
      }
      if (form.item3 == 1) {
        form.item3 = 2
      }
      if (form.item4 == 1) {
        form.item4 = 2
      }
      let result = form.age + form.item1 + form.item2 + form.item3 + form.item4 + form.item5 + form.item6 + form.item7
      console.log(result);
      self.hasScore = true
      if (result == 0) {
        self.descTxt = ''
      } else if (result < 4) {
        self.descTxt = '低危患者'
      } else if (result < 7) {
        self.descTxt = '中危患者'
      } else {
        self.descTxt = '高危患者'
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/TIMI_STEMI.vue